<template>
  <div class="detalhesPedidos" v-if="objPedido">
    <div>
      <div
        class="d-flex justify-content-between mt-4 flex-column flex-lg-row align-items-baseline align-items-lg-center"
      >
        <div class="mt-2" v-if="objPedido.pedido.dataRegistro">
          Data do pedido:
          <br />
          {{ formatDate(objPedido.pedido.dataRegistro) }}
        </div>
        <div class="mt-2" v-if="objPedido.pedido.dataAtualizacao">
          Data da ultima atualização:
          <br />
          {{ formatDate(objPedido.pedido.dataAtualizacao) }}
        </div>
        <div class="mt-2">
          Situação:
          <br />
          {{ objPedido.pedido.statusExibicao }}
        </div>
        <div class="mt-2">
          Valor:
          <br />
          {{ objPedido.pedido.valorTotal | currency }}
        </div>
        <div class="d-flex flex-column mt-2">
          <button
            class="btn btn-outline-danger"
            @click="showAlert"
            v-if="objPedido.pedidosFilho[0].pedidoDTO.podeCancelar"
          >
            Cancelar Pedido
          </button>
          <button class="btn btn-outlinet m-2" @click="meusPedidos">
            Meus Pedidos
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-lg-12 col-xl-5" v-if="isCheketMethod">
        <PagamentoPedido
          v-if="objPedido"
          :objPedido="objPedido.pedido"
          :colSize="12"
        ></PagamentoPedido>
      </div>
      <div :class="isCheketMethod ? 'col-lg-12 col-xl-7' : 'col-12'">
        <div>
          <div
            v-for="(pedidoFilho, indexPedidoFilho) in objPedido.pedidosFilho"
            :key="indexPedidoFilho"
            class="card p-0"
          >
            <div class="card-header">
              <img
                :src="
                  pedidoFilho.pedidoDTO.redeLoja
                    ? pedidoFilho.pedidoDTO.redeLoja.urlLoja
                    : ''
                "
                height="auto"
                class="imagemLoja"
              />
              <strong>
                {{
                  pedidoFilho.pedidoDTO.redeLoja
                    ? pedidoFilho.pedidoDTO.redeLoja.nome
                    : ''
                }}

                <span class="float-right">
                  Nº #{{
                    objPedido &&
                    !!pedidoFilho.pedidoDTO.codigoReferencia &&
                    pedidoFilho.pedidoDTO.codigoReferencia
                      .toUpperCase()
                      .substring(0, 8)
                  }}
                </span>
              </strong>
            </div>

            <div class="float-left justify-content-between m-3">
              <span v-if="pedidoFilho.pedidoDTO.enderecoEntrega">
                <strong>Endereço de entrega</strong>
                <br />
                <small style="color: #757575;">
                  <strong>CEP:</strong>
                  {{ pedidoFilho.pedidoDTO.enderecoEntrega.cep }}
                  <strong>Endereço:</strong>
                  {{ pedidoFilho.pedidoDTO.enderecoEntrega.endereco }}
                  <strong>Complemento:</strong>
                  {{ pedidoFilho.pedidoDTO.enderecoEntrega.complemento }}
                  <strong>Número:</strong>
                  {{ pedidoFilho.pedidoDTO.enderecoEntrega.numero }}
                  <strong>Bairo:</strong>
                  {{ pedidoFilho.pedidoDTO.enderecoEntrega.bairro }}
                  <strong>Cidade:</strong>
                  {{ pedidoFilho.pedidoDTO.enderecoEntrega.cidade }}
                  <strong>UF:</strong>
                  {{ pedidoFilho.pedidoDTO.enderecoEntrega.estado }}
                </small>
              </span>
            </div>

            <div class="card-header mt-3"><strong>ITENS DO PEDIDO</strong></div>
            <div class="card-body">
              <div
                v-for="(item, indexItem) in pedidoFilho.pedidoDTO.itens"
                :key="indexItem"
              >
                <div class="d-flex align-items-center my-2">
                  <img
                    :src="obterImagemPrincipal(item.produto.imagemList)"
                    height="auto"
                    class="imagemProdutos"
                  />
                  <div class="d-flex flex-column w-100">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex flex-column">
                        <span class="text-nowrap">{{ item.produto.nome }}</span>
                        <small class="text-nowrap text-black-50">
                          Quantidade: {{ item.quantidade }}
                        </small>
                        <small class="text-nowrap text-black-50">
                          Valor do produto: {{ item.valorUnitario | currency }}
                        </small>
                        <small
                          style="color: #757575;"
                          v-if="
                            item.freteSelecionado &&
                            item.freteSelecionado.tipoCalculoFrete !=
                              'RETIRAR_NA_LOJA'
                          "
                        >
                          Frete:
                          <strong>
                            {{
                              item.freteSelecionado.valorTotalFrete | currency
                            }}
                          </strong>
                          entregue por
                          <strong>
                            {{ item.freteSelecionado.nomeLogistica }}
                          </strong>
                        </small>
                      </div>
                      <span class="text-nowrap">
                        {{
                          (item.quantidade * item.valorUnitario +
                            (item.freteSelecionado
                              ? item.freteSelecionado.valorTotalFrete
                              : 0))
                            | currency
                        }}
                      </span>
                    </div>
                    <div
                      class="align-self-baseline badge badge-light border-left px-2"
                      style="border-left-width: 6px !important;"
                      v-for="(modificador,
                      indexCategoriaModificadorList) in item.produto
                        .categoriaModificadorList"
                      :key="indexCategoriaModificadorList"
                    >
                      {{ modificador.nome }}
                      {{ modificador.produtoModificadorList[0].nome }}
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <div class="d-flex justify-content-between font-size-1-5">
                <span v-if="pedidoFilho.pedidoDTO.cupom">
                  <small>Cupom utilizado</small>
                  <span class="text-uppercase small">
                    <b>{{ pedidoFilho.pedidoDTO.cupom.codigoCupom }}</b>
                    {{ pedidoFilho.pedidoDTO.cupom.valorDesconto * 100
                    }}{{
                      pedidoFilho.pedidoDTO.cupom.premiacaoTipo ===
                      'PERCENTUAL_DESCONTO'
                        ? '%'
                        : ''
                    }}
                  </span>
                  <small>de desconto</small>
                </span>
              </div>
              <div class="float-right">
                <div class="d-flex justify-content-between">
                  <small>Compra</small>
                  <strong>
                    {{ pedidoFilho.pedidoDTO.valorCompra | currency }}
                  </strong>
                </div>
                <div class="d-flex justify-content-between">
                  <small class="pr-5">Frete</small>
                  <strong>
                    {{
                      !(pedidoFilho.pedidoDTO.valorFrete > 0)
                        ? '-'
                        : !(pedidoFilho.pedidoDTO.valorFrete > 0)
                        ? 'Grátis'
                        : pedidoFilho.pedidoDTO.valorFrete | currency
                    }}
                  </strong>
                </div>
                <div class="d-flex justify-content-between">
                  <small class="pr-5">Desconto</small>
                  <strong>
                    {{
                      !(pedidoFilho.pedidoDTO.valorDesconto > 0)
                        ? '-'
                        : !(pedidoFilho.pedidoDTO.valorDesconto > 0)
                        ? 'Grátis'
                        : pedidoFilho.pedidoDTO.valorDesconto | currency
                    }}
                  </strong>
                </div>

                <div class="d-flex justify-content-between font-size-1-5">
                  <span class="pr-5">Total</span>
                  <strong>
                    {{ pedidoFilho.pedidoDTO.valorTotal | currency }}
                  </strong>
                </div>
              </div>
            </div>
            <div
              class="card-footer d-flex justify-content-lg-center justify-content-md-left eventosPedidos mt-4 py-3"
              v-html="htmlStep(pedidoFilho.eventos)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PagamentoPedido from './DetalhePagamentoPedido.vue'

export default {
  props: ['objPedido'],
  components: {
    PagamentoPedido,
  },
  data() {
    return {
      motivoCancelamento: '',
      mostrarHistorico: true,
      etapasPedido: [
        {
          urlIcone:
            'https://pagglo-cdn.s3.amazonaws.com/marketplace/icones-email/icon_pedido',
          label: 'Pedido realizado',
          grupoStatus: [
            'PEDIDO_CRIADO',
            'PEDIDO_VISUALIZADO',
            'ITEM_ADICIONADO',
            'ITEM_MODIFICADO',
            'ITEM_REMOVIDO',
            'PEDIDO_CHECKOUT',
            'PEDIDO_MODIFICADO',
            'PEDIDO_ACEITO_PELA_LOJA',
            'PEDIDO_EM_ANALISE',
          ],
        },
        {
          urlIcone:
            'https://pagglo-cdn.s3.amazonaws.com/marketplace/icones-email/icon_pagamento',
          label: 'Pagamento confimado',
          grupoStatus: ['PEDIDO_PAGO'],
        },
        {
          urlIcone:
            'https://pagglo-cdn.s3.amazonaws.com/marketplace/icones-email/icon_empacotamento',
          label: 'Em separação',
          grupoStatus: ['PEDIDO_EM_PROCESSAMENTO'],
        },
        {
          urlIcone:
            'https://pagglo-cdn.s3.amazonaws.com/marketplace/icones-email/icon_transporte',
          label: 'Em transporte',
          grupoStatus: ['PEDIDO_SAIU_PARA_ENTREGA'],
        },
        {
          urlIcone:
            'https://pagglo-cdn.s3.amazonaws.com/marketplace/icones-email/icon_entrega',
          label: 'Pedido entregue',
          grupoStatus: ['PEDIDO_ENVIADO_PARA_LOJA', 'PEDIDO_ENTREGUE'],
        },
      ],
      etapasPedidoDigital: [
        {
          urlIcone:
            'https://pagglo-cdn.s3.amazonaws.com/marketplace/icones-email/icon_pedido',
          label: 'Pedido realizado',
          grupoStatus: [
            'PEDIDO_CRIADO',
            'PEDIDO_VISUALIZADO',
            'ITEM_ADICIONADO',
            'ITEM_MODIFICADO',
            'ITEM_REMOVIDO',
            'PEDIDO_CHECKOUT',
            'PEDIDO_MODIFICADO',
            'PEDIDO_ACEITO_PELA_LOJA',
            'PEDIDO_EM_ANALISE',
          ],
        },
        {
          urlIcone:
            'https://pagglo-cdn.s3.amazonaws.com/marketplace/icones-email/icon_pagamento',
          label: 'Pagamento confimado',
          grupoStatus: ['PEDIDO_PAGO'],
        },
      ],
    }
  },
  methods: {
    isCheketMethod() {
      return ['PIX', 'BOLETO'].includes(this.objPedido.pedido.pagamento.metodo)
    },
    showAlert() {
      this.$swal({
        title: 'Motivo do cancelamento',
        html: `<textarea id="motivo" class="form-control"></textarea>`,
        confirmButtonText: 'Enviar motivo',
        cancelButtonText: 'Fechar',
        showCancelButton: true,
      }).then((action) => {
        const motivo = document.getElementById('motivo').value.trim()
        if (action.isConfirmed && !!motivo) {
          this.$emit('cancelarPedido', motivo)
        }
      })
    },
    formatCodigoPedido(codigoReferencia) {
      return codigoReferencia == null
        ? ''
        : codigoReferencia.toUpperCase().substring(0, 8)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    meusPedidos() {
      this.$router.push(`/pedidos`)
    },

    obterImagemPrincipal(list) {
      const item = list.find((o) => o.imagemPrincipal)
      return item && list && list.length
        ? item.urlImagem || list[0].urlImagem
        : 'https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png'
    },
    htmlStep(eventos) {
      let nUltimoEvento = 0

      const _etapasPedido = this.objPedido.pedidosFilho[0].pedidoDTO
        .possuiProdutoFisico
        ? this.etapasPedido
        : this.etapasPedidoDigital

      const htmlEventos = _etapasPedido.map((etapa, index) => {
        const eventoDados =
          eventos
            .filter((o) =>
              etapa.grupoStatus.find((status) => status === o.tipoEvento),
            )
            .pop() || null
        if (eventoDados) nUltimoEvento = index
        const eventoData = eventoDados
          ? this.formatDate(eventoDados.dataRegistro)
          : '00/00/0000 00:00:00'
        return `<div class="d-flex flex-column align-items-center text-center ${
          eventoDados ? 'eventoOk' : ''
        }"><small>${eventoData}</small><div class="linhaTempo"><div class="circuloImg"><img src="${`${
          etapa.urlIcone
        }${
          eventoDados ? '_ok' : ''
        }.png`}" height="auto" class="iconesEventos"/></div></div><small>${
          etapa.label
        }</small></div>`
      })
      htmlEventos[nUltimoEvento] = htmlEventos[nUltimoEvento].replace(
        'eventoOk',
        'eventoOk ultimoEvento',
      )
      return htmlEventos.join('')
    },
  },
}
</script>

<style scoped lang="scss">
.dashed {
  border-style: dashed;
}

ul.timeline {
  list-style-type: none;
  position: relative;
}

ul.timeline:before {
  content: ' ';
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 7;
}

ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.timeline > li:before {
  content: ' ';
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 7;
}

.imagemLoja {
  margin-right: 20px;
  width: 35px;
}

.imagemProdutos {
  margin-right: 20px;
  width: 38px;
}
</style>
<style lang="scss">
.iconesEventos {
  width: 50px;
}

small {
  &.eventoOk {
    color: green;
  }

  &.ultimoEvento {
    font-weight: bold;
  }
}

.eventosPedidos {
  width: 100%;
  overflow-x: scroll;
  .linhaTempo {
    position: relative;
    width: 120px;
    &:before,
    &:after {
      content: '';
      border-top: 1px solid #ccc;
      width: 50px;
      position: absolute;
      top: 48px;
      z-index: 1;
    }

    &:before {
      left: 0;
    }

    &:after {
      right: 0;
    }
  }

  .circuloImg {
    border-radius: 1000px;
    border: 1px solid #ccc;
    position: relative;
    background-color: #fff;
    z-index: 5;
    width: 66px;
    height: 66px;
    padding: 8px;
    margin: 11px auto;
  }

  img {
    z-index: 2;
  }

  div:first-child > div:before,
  div:last-child > div:after {
    border-color: transparent !important;
  }

  .eventoOk {
    div,
    small {
      border-color: green;
      color: green;
    }

    .linhaTempo {
      &:before,
      &:after {
        border-color: green;
      }
    }
  }

  .ultimoEvento {
    .circuloImg {
      width: 80px;
      height: 80px;
      margin: 4px auto;
      padding: 14px;
      border-width: 2px;
    }

    .linhaTempo:after {
      border-color: #ccc;
    }

    small {
      font-weight: bold;
    }
  }

  small {
    display: inline-block;
    width: 80px;
    line-height: 1rem;
  }
}

///768
</style>
